// extracted by mini-css-extract-plugin
export default {"dot-container":"CheckMark_dot-container__1AgEU","small":"CheckMark_small__C8MJn","dot":"CheckMark_dot__qzmjB","veg":"CheckMark_veg__Pc3lk","non-veg":"CheckMark_non-veg__qYxfk"};